import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconPermissionDenyColor from './icon-permission-deny-color.vue';

const IconPermissionDenyColor = Object.assign(_IconPermissionDenyColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconPermissionDenyColor.name, _IconPermissionDenyColor);
  }
});

export default IconPermissionDenyColor;
